import { createAsyncThunk } from "@reduxjs/toolkit";
import { getData, postData, putData, deleteData } from "../../../../services/apiEndpoints";


// GET ALL (no pagination)
export const fetchAssetsThunk = createAsyncThunk(
    "fixedAssets/fetchAssets",
    async (_, { rejectWithValue }) => {
        try {
            const response = await getData(`/finance/assets/get-assets`);
            return response;
        } catch (error) {
            return rejectWithValue(
                error?.response?.data?.message || "Failed to fetch assets"
            );
        }
    }
);


// CREATE
export const createAssetThunk = createAsyncThunk(
    "fixedAssets/createAsset",
    async (data, { rejectWithValue }) => {
        try {
            const response = await postData(`/finance/assets/create-asset`, data);
            return response;
        } catch (error) {
            return rejectWithValue(
                error?.response?.data?.message || "Failed to create asset"
            );
        }
    }
);


// UPDATE
export const updateAssetThunk = createAsyncThunk(
    "fixedAssets/updateAsset",
    async ({ id, data }, { rejectWithValue }) => {
        try {
            const response = await putData(`/finance/assets/update-asset/${id}`, data);
            return response;
        } catch (error) {
            return rejectWithValue(
                error?.response?.data?.message || "Failed to update asset"
            );
        }
    }
);


// DELETE
export const deleteAssetThunk = createAsyncThunk(
    "fixedAssets/deleteAsset",
    async (id, { rejectWithValue }) => {
        try {
            const response = await deleteData(`/finance/assets/delete-asset/${id}`);
            return response;
        } catch (error) {
            return rejectWithValue(
                error?.response?.data?.message || "Failed to delete asset"
            );
        }
    }
);
